import { useEffect, useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// Material Dashboard 2 React contexts
import CustomItem from "./posicaoChart";
import AssetTypeAllocationList from "./assetTypeAllocationList";
import { buildAllocationByType, buildGlobalPosition } from "./positionUtils";
// import { getProperty } from "layouts/dashboard/Api/dashboardApi";
import { Card } from "@mui/material";
import { getProperty } from "layouts/dashboard/api/dashboardApi";
import { useMaterialUIController } from "context";

function Posicao() {
    const [globalPosition, setGlobalPosition] = useState([]);
    const [allocationByType, setAllocationByType] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    useEffect(() => {
        getAssetsPosition();
    }, []);

    const getAssetsPosition = async () => {
        setIsLoading(true);

        await getProperty()
            .then((data) => {
                const positions = Array.isArray(data) ? data : [];

                setGlobalPosition(buildGlobalPosition(positions));
                setAllocationByType(buildAllocationByType(positions));
            })
            .catch(() => {
                setGlobalPosition([]);
                setAllocationByType([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Card>
                <MDBox pt={2} px={2} lineHeight={1.25}>
                    <MDTypography variant="h6" fontWeight="medium">
                        Posição global
                    </MDTypography>
                    <MDBox mb={1}>
                        <MDTypography variant="button" color="text">
                            Gráfico da posição patrimonial global.
                        </MDTypography>
                    </MDBox>
                </MDBox>
                {globalPosition.length > 0 ? (
                    <CustomItem data={globalPosition} isDarkMode={darkMode} />
                ) : (
                    <MDBox px={2} pb={3}>
                        <MDTypography variant="button" color="text">
                            {isLoading ? "Carregando posição..." : "Nenhuma posição encontrada para exibir o gráfico."}
                        </MDTypography>
                    </MDBox>
                )}
            </Card>

            <MDBox mt={3}>
                <Card>
                    <MDBox pt={2} px={2} lineHeight={1.25}>
                        <MDTypography variant="h6" fontWeight="medium">
                            Exposição por tipo de ativo
                        </MDTypography>
                        <MDBox mb={1}>
                            <MDTypography variant="button" color="text">
                                Distribuição percentual da exposição da carteira por tipo de ativo.
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                    <AssetTypeAllocationList data={allocationByType} isLoading={isLoading} />
                </Card>
            </MDBox>

            <MDBox mb={2} mt={2} />
            <Footer />
        </DashboardLayout>
    );
}

export default Posicao;
